<template>
  <div>
    <Layout>
      <Content style="background-color: #fff">
        <div class="ace-container">
          <Form inline ref="opsForm" :label-width="5" onsubmit="return false;" style="height: 45px; margin-top: 10px; margin-left: 5px">
            <FormItem>
              <span>当前库：{{ data.db ? data.db : '无' }}</span>
            </FormItem>
            <FormItem>
              <Button icon="md-color-wand" type="info" @click="format">格式美化</Button>
            </FormItem>
            <FormItem>
              <Button icon="md-eye" type="primary" @click="explain">查看执行计划</Button>
            </FormItem>
            <FormItem>
              <Select v-model="returnRow" style="width:80px">
                <Option disabled label="返回行数" value="0"></Option>
                <Option label="100" value='100'></Option>
                <Option label="500" value='500'></Option>
                <Option label="1000" value='1000'></Option>
              </Select>
            </FormItem>
            <FormItem>
              <Button icon="md-play" type="success" @click="execute" :loading="executing">执行SQL</Button>
            </FormItem>
            <FormItem>
              <Button icon="md-undo" @click="undo" :disabled=hasUndo>撤销</Button>
            </FormItem>
            <FormItem>
              <Button icon="md-redo" @click="redo" :disabled=hasRedo>重做</Button>
            </FormItem>
            <FormItem>
              <Poptip
                confirm
                title="请确认是否导出?"
                @on-ok="exportData"
                ok-text="确认"
                cancel-text="取消"
                placement="bottom">
                <Button icon="md-download" type="warning">导出结果</Button>
              </Poptip>
            </FormItem>
          </Form>
          <div class="ace-editor" v-bind:id="'ace_'+ data.id"></div>
          <div class="config-panel" v-show="toggle">
            <div>
              <div class="item">
                <label class="title">语言</label>
                <Select class="value" v-model="modePath" @on-change="handleModelPathChange" size="small">
                  <Option v-for="mode in modeArray"
                          :key="mode.name"
                          :label="mode.name"
                          :value="mode.path">
                  </Option>
                </Select>
              </div>

              <div class="item">
                <label class="title">主题</label>
                <Select class="value" v-model="themePath" @on-change="handleThemePathChange" size="small">
                  <Option v-for="theme in themeArray"
                          :key="theme.name"
                          :label="theme.name"
                          :value="theme.path">
                  </Option>
                </Select>
              </div>

              <div class="item">
                <label class="title">自动换行</label>
                <Select class="value" v-model="wrap" @on-change="handleWrapChange" size="small">
                  <Option v-for="wrap in wrapArray"
                          :key="wrap.name"
                          :label="wrap.name"
                          :value="wrap.value">
                  </Option>
                </Select>
              </div>
            </div>
          </div>
          <div class="bookmarklet" @click="toggle = !toggle"></div>
        </div>
        <Row>
          <SQLResults ref="SQLResults" :callbackdata="callbackdata"></SQLResults>
        </Row>
      </Content>
      <Sider hide-trigger :style="{background: '#fff'}" :class="{ 'hang-up': !commonSQLShow }">
        <div class="common-sql">
          <div class="common-sql-hide" v-on:click="commonSQLShow = !commonSQLShow" v-if="!commonSQLShow">
            <div style="margin: 0 auto; ">
              <a style="color: #fff; line-height: 24px">
                <Icon type="md-arrow-dropleft-circle" size="14"/>
              </a>
            </div>
            <div style="margin: 0 auto; width: 15px; line-height: 24px; word-wrap: break-word;">常用SQL</div>
          </div>
          <div v-else>
            <Spin fix v-show="getCommonSQLLoading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>正在获取常用SQL</div>
            </Spin>
            <div class="common-sql-header">
              <span>常用SQL</span>
              <span style="float: right; margin-right: 5px; cursor: pointer">
              <Tooltip content="收起" transfer>
                <a style="color: #fff" v-on:click="commonSQLShow = !commonSQLShow"><Icon type="md-arrow-dropright-circle" size="14" /></a>
              </Tooltip>
            </span>
            </div>
            <Collapse v-model="openCommonSQLCategory" simple class="common-sql-collapse common-sql-list">
              <Panel v-for="(value, key, index) in commonSQL" :name="'category_' + index" :key="'category_' + index">
                <span>{{ key }}</span>
                <div slot="content" style="padding-left: 15px">
                  <Collapse :value="openCommonSQLTag" simple class="common-sql-collapse">
                    <Panel v-for="(tagValue, tagKey, tagIndex) in value" :name="index + '_tag_' + tagIndex" :key="index + '_tag_' + tagIndex">
                      <span>{{ tagKey }}</span>
                      <div slot="content">
                        <ul>
                          <li :class="{ 'sql-item': true, 'sql-item-active': currentSelectedCommonSQL === sqlItem.key }" href="javascript:void(0)"
                              v-on:click="selectCommonSQL(sqlItem)" v-for="(sqlItem, sqlIndex) in tagValue" :key="index + '_' + tagIndex + '_sqlItem_' + sqlIndex">
                            <span>{{ sqlItem.key }}</span>
                          </li>
                        </ul>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
              </Panel>
            </Collapse>
          </div>
        </div>
      </Sider>
    </Layout>
  </div>
</template>
<script>
import { explainSQL, executeSQL, getCommonSQL } from '@/api/mysql'
import SQLResults from './sqlResults'
import sqlFormatter from 'sql-formatter'
import '@/view/database/ace-export'

const wrapArray = [
  {
    name: '开启',
    value: 1
  },
  {
    name: '关闭',
    value: 0
  }
]

const themeArray = [
  {
    name: 'sqlserver',
    path: 'ace/theme/sqlserver'
  },
  {
    name: 'monokai',
    path: 'ace/theme/monokai'
  },
  {
    name: 'terminal',
    path: 'ace/theme/terminal'
  },
  {
    name: 'eclipse',
    path: 'ace/theme/eclipse'
  },
  {
    name: 'tomorrow',
    path: 'ace/theme/tomorrow'
  },
  {
    name: 'xcode',
    path: 'ace/theme/xcode'
  }
]

const modeArray = [
  {
    name: 'SQL',
    path: 'ace/mode/sql'
  },
  {
    name: 'JavaScript',
    path: 'ace/mode/javascript'
  },
  {
    name: 'HTML',
    path: 'ace/mode/html'
  },
  {
    name: 'CSS',
    path: 'ace/mode/css'
  },
  {
    name: 'SCSS',
    path: 'ace/mode/scss'
  },
  {
    name: 'Json',
    path: 'ace/mode/json'
  },
  {
    name: 'Java',
    path: 'ace/mode/java'
  },
  {
    name: 'Text',
    path: 'ace/mode/text'
  }
]
export default {
  name: 'execSQL',
  components: {
    SQLResults
  },
  data () {
    return {
      data: {},
      returnRow: '100',
      hasRedo: true,
      hasUndo: true,
      wrap: 1,
      themePath: 'ace/theme/sqlserver',
      modePath: 'ace/mode/sql',
      modeArray: modeArray,
      wrapArray: wrapArray,
      themeArray: themeArray,
      toggle: false,
      aceEditor: '',
      results: [],
      dateValue: [
        new Date(new Date().setDate(new Date().getDate() - 29)).toISOString().slice(0, 10),
        new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10)
      ],
      execLog: {
        data: [],
        columns: [
          {
            title: '时间',
            key: 'create_time',
            align: 'center',
            width: 165,
            render: (h, params) => {
              return h('div', new Date(params.row.create_time).toLocaleString())
            }
          },
          {title: 'SQL', key: 'sql', tooltip: true},
          {title: '执行结果',
            key: 'is_failed',
            width: 150,
            render: (h, params) => {
              return h('div', params.row.is_failed ? '执行失败' : '执行成功')
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5,
        loading: false
      },
      executing: false,
      commonSQLShow: false,
      commonSQL: [],
      getCommonSQLLoading: false,
      openCommonSQLCategory: ['category_0', 'category_1'],
      openCommonSQLTag: [],
      currentSelectedCommonSQL: ''
    }
  },
  props: {
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  created: function () {
    this.getCommonSQLList()
  },
  mounted () {
    this.initAceEditor(this.callbackdata)
  },
  watch: {
    'data': function () {
      this.$nextTick(function () {
        const aceName = 'ace_' + this.data.id
        this.aceEditor = ace.edit(aceName, {
          maxLines: 30,
          minLines: 20,
          fontSize: 14,
          value: '',
          theme: this.themePath,
          mode: this.modePath,
          wrap: this.wrap,
          tabSize: 4
        })
        // 激活自动提示
        this.aceEditor.setOptions({
          enableSnippets: true,
          enableLiveAutocompletion: true,
          enableBasicAutocompletion: true,
          printMargin: false,
          printMarginColumn: 120
        })
        this.aceEditor.getSession().on('change', this.change)
      })
    }
  },
  methods: {
    // 初始化编辑器
    initAceEditor (data) {
      this.data = data
    },
    // 查看执行计划
    explain () {
      let data = {
        id: this.data.instance_id,
        db: this.data.db,
        sql: this.aceEditor.getSelectedText() ? this.aceEditor.getSelectedText() : this.aceEditor.getSession().getValue()
      }
      let that = this
      explainSQL(data).then(res => {
        that.results = []
        res.data.results.forEach(function (item, index) {
          that.results.push({'id': index + 1, 'res': item['data'], 'columns': []})
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              that.results[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
        })
        this.$refs.SQLResults.showResult(that.results)
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 执行
    execute () {
      let data = {
        id: this.data.instance_id,
        db: this.data.db,
        sql: this.aceEditor.getSelectedText() ? this.aceEditor.getSelectedText() : this.aceEditor.getSession().getValue(),
        limit: this.returnRow
      }
      let that = this
      that.executing = true
      executeSQL(data).then(res => {
        that.results = []
        res.data.results.forEach(function (item, index) {
          that.results.push({'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg']})
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              that.results[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
        })
        that.executing = false
        this.$refs.SQLResults.showResult(that.results)
      }).catch(res => {
        that.executing = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 格式美化
    format () {
      this.aceEditor.setValue(sqlFormatter.format(this.aceEditor.getSession().getValue()))
    },
    // 导出
    exportData () {
      this.$refs.SQLResults.exportData()
    },
    // 选择语言
    handleModelPathChange (modelPath) {
      this.aceEditor.getSession().setMode(modelPath)
    },
    // 选择主题
    handleThemePathChange (themePath) {
      this.aceEditor.setTheme(themePath)
    },
    // 修改自动换行
    handleWrapChange (wrap) {
      this.aceEditor.getSession().setUseWrapMode(wrap === 1)
    },
    change () {
      this.$emit('input', this.aceEditor.getSession().getValue())
      let um = this.aceEditor.getSession().getUndoManager()
      this.hasUndo = !um.hasUndo()
      this.hasRedo = !um.hasRedo()
    },
    // 重做
    redo () {
      let um = this.aceEditor.getSession().getUndoManager()
      um.redo(this.aceEditor.getSession())
    },
    // 撤销
    undo () {
      let um = this.aceEditor.getSession().getUndoManager()
      um.undo(this.aceEditor.getSession())
    },
    // 获取常用SQL
    getCommonSQLList () {
      this.getCommonSQLLoading = true
      getCommonSQL().then(res => {
        this.getCommonSQLLoading = false
        this.commonSQL = res.data
        this.commonSQLShow = true
      }).catch(res => {
        this.getCommonSQLLoading = false
      })
    },
    // 选择常用SQL
    selectCommonSQL (item) {
      let oldValue = this.aceEditor.getValue()
      this.aceEditor.setValue(oldValue + '\n\n' + item.sql)
      this.currentSelectedCommonSQL = item.key
    }
  }
}
</script>

<style lang='scss' scoped>
  .ace-container {
    margin-bottom: 10px;
    position: relative;
    .config-panel {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 30%;
      height: 100%;
      overflow: scroll;
      box-shadow: grey -5px 2px 3px;
      background-color: rgba(255, 255, 255, 0.5);
      z-index: 1;

      .item {
        margin: 10px auto;
        text-align: center;

        .title {
          color: black;
          margin: 0 10px;
          font-size: 14px;
        }
      }
    }

    .bookmarklet {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 15px;
      height: 15px;
      z-index: 2;
      cursor: pointer;
      border-width: 7px;
      border-style: solid;
      border-color: lightblue gray gray rgb(206, 173, 230);
      border-image: initial;
    }

  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .hang-up {
    width: 30px !important;
    min-width: 30px !important;
    max-width: 30px !important;
    margin-right: 5px;
  }
  .common-sql-hide {
    cursor: pointer;
    width: 30px;
    background-color: #001529;
    color: #fff;
    text-align:center;
  }
  .common-sql {
    border: 1px solid #EDEDED;
    margin-left: 5px;
    .common-sql-header {
      color: #fff;
      background-color: #001529;
      height: 30px;
      line-height: 30px;
      padding-left: 10px;
    }
    .common-sql-list {
      font-size: 12px;
      border: 1px solid #999;
      max-height: 670px;
      overflow-y: auto;
    }
    .common-sql-list::-webkit-scrollbar {
      width: 1px;
    }
    .common-sql-list::-webkit-scrollbar-track {
      border-radius: 5px;
      background-color: #eee;
    }
    .common-sql-list::-webkit-scrollbar-thumb {
      background: #001529;
    }
    .common-sql-collapse {
      border: 0;
    }
    .sql-item {
      padding-left: 40px;
      list-style-type: none;
      cursor: pointer;
      line-height: 25px;
      text-transform: lowercase;
      font-size: 13px;
    }
    .sql-item-active {
      color: #fff;
      background-color: #001529;
    }
    .sql-item:hover, .sql-item:visited {
      color: #515a6e;
      background-color: rgb(243, 243, 243);
    }
  }

</style>
